// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import AdminShellController from "./admin_shell_controller"
application.register("admin-shell", AdminShellController)

import EventConfigurationController from "./event_configuration_controller"
application.register("event-configuration", EventConfigurationController)

import EntryFlowController from "./entry_flow_controller"
application.register("entry-flow", EntryFlowController)

import ClickableRowController from "./clickable_row_controller"
application.register("clickable-row", ClickableRowController)

import EventOrderController from "./event_order_controller"
application.register("event-order", EventOrderController)
